import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Sparkle, Copy, Check } from "@phosphor-icons/react";

export default function PromptLab() {
    const [prompts, setPrompts] = useState([]);
    const [copiedId, setCopiedId] = useState(null);

    useEffect(() => {
        api.get("/prompts").then((r) => setPrompts(r.data)).catch(() => {});
    }, []);

    const copy = (p) => {
        navigator.clipboard.writeText(p.prompt);
        setCopiedId(p.id);
        toast.success(`COPIED: ${p.title}`);
        setTimeout(() => setCopiedId(null), 1500);
    };

    return (
        <section data-testid="prompt-lab-section" className="bg-[#0A0A0A] border border-white/10 relative overflow-hidden h-full flex flex-col">
            <div className="px-6 py-4 border-b border-white/10 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <Sparkle size={20} className="text-electric-blue" weight="duotone" />
                    <div>
                        <p className="label-mono text-electric-blue">AI PROMPT LAB</p>
                        <h2 className="font-heading font-bold text-lg">Click-to-Copy Arsenal</h2>
                    </div>
                </div>
                <span className="label-mono text-[10px]">{prompts.length} PROMPTS</span>
            </div>

            <div className="flex-1 overflow-y-auto scrollbar-thin divide-y divide-white/5">
                {prompts.map((p, i) => (
                    <button
                        key={p.id}
                        data-testid={`prompt-card-${i}`}
                        onClick={() => copy(p)}
                        className="w-full text-left px-5 py-4 hover:bg-electric-blue/5 transition-colors group flex items-start gap-3"
                    >
                        <div className="flex-shrink-0 w-9 h-9 bg-electric-blue/10 border border-electric-blue/30 flex items-center justify-center">
                            {copiedId === p.id ? (
                                <Check size={14} weight="bold" className="text-emerald-400" />
                            ) : (
                                <Copy size={14} weight="bold" className="text-electric-blue group-hover:scale-110 transition-transform" />
                            )}
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1">
                                <p className="font-semibold text-sm group-hover:text-electric-blue transition-colors">
                                    {p.title}
                                </p>
                                <span className="label-mono text-[9px] text-muted-foreground">[{p.category}]</span>
                            </div>
                            <p className="text-xs text-muted-foreground line-clamp-2 font-mono">{p.prompt}</p>
                        </div>
                    </button>
                ))}
                {prompts.length === 0 && (
                    <div className="p-8 text-center label-mono text-muted-foreground">PROMPT BANK LOADING...</div>
                )}
            </div>
        </section>
    );
}
